/*=========================================================================================
  File Name: module-products.js
  Description: Products Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-products-state';
import mutations from './module-products-mutations';
import actions from './module-products-actions';
import getters from './module-products-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
